/**
 * Created by mauget on 3/2/16.
 */

// SettingsDetailView.js

import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';

import DashboardModel   from 'DashboardModel.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/user-group-search-detail-view.ejs';
import BaseTableView from 'properties/BaseTableView.js'
import util from 'util/Util.js';
import RestService from 'RestService.js';
import eventBus         from 'EventBus.js';

class UserGroupSearchDetailView extends BaseTableView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.events = {
            'keypress input[type="text"]': 'updateFilters',
            'focusout input[type="text"]': 'updateFilters',
            'click #view-user':'viewGroupDetails',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToAccountSettings'
        };

        this.model.set({
            colModel: [
                {
                    name: 'GroupId',
                    index: 'GroupId',
                    editable: false,
                    hidden: true
                },{
                    name: 'GroupGUID',
                    index: 'GroupGUID',
                    editable: false,
                    hidden: true
                },{
                    name: 'Name',
                    index: 'Name',
                    editable: false
                }

            ],
            colNames: ['GroupId','GroupGUID','Name']
        });

        this.listenTo(this.model, 'change', this.render);
        this.onResize();
        return this;
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    updateFilters(event){
        // Saving search values inside the model, so the search can be preserved on renders.
        if (event.type === 'keypress'){
            let code = event.keyCode ? event.keyCode : event.which;
            if (code === 13){
                $(event.target).blur();
                return;
            }
        }
        
        if (event.type === 'focusout'){
            const targetValue = event.target.value;
            this.model.set('search-' + event.target.name, targetValue, constants.MODEL_SILENT);
            this.performSearch();
        }
    }

    onCellSelect(rowId, iCol, cellContent,e){
        $(this.gridEl).jqGrid('setSelection',rowId);
        $("#view-user").prop('disabled',false);
    }

    ondblClickRow(rowId){
        this.switchToGroupDetails(rowId);
    }

    viewGroupDetails(event){
        event.preventDefault();
        let selRowId = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        this.switchToGroupDetails(selRowId);
    }

    switchToGroupDetails(selectedRow){
        let rowData = $(this.gridEl).getRowData(selectedRow);
        let groupIdToOpen=rowData['GroupId'];
        const eventValues={
            detailPage: 'GroupDetailsView',
            payload:{
                groupId:groupIdToOpen
            }
        };
        eventBus.trigger(constants.SWITCH_DETAIL_USER,eventValues);
    }

    performSearch(){
        // Adding the '%' wildcard to the input text searches if any, requested by the API.
        const groupName = this.model.get('search-groupName') ? this.model.get('search-groupName').trim() : '*';

        RestService.searchUserGroups(groupName).then((userGroupData)=>{
            this.model.set('totalRecords',userGroupData.TotalRecords,{silent:true});

            if(userGroupData.UserGroups) {
                let userGroups = userGroupData.UserGroups.UserGroup instanceof Array
                    ? userGroupData.UserGroups.UserGroup
                    : [userGroupData.UserGroups.UserGroup];
                userGroups = userGroups.map((element)=>{
                    return {
                        GroupId: element['@id'],
                        GroupGUID: 0,
                        Name: element['@name']
                    }
                });
                this.model.set('gridData', userGroups, {silent: true});
            }
            else{
                this.model.set('gridData', [], {silent: true});
            }

            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: constants.USER_GROUPS_SETTINGS_TITLE, id: 'goToUserGroups'}
            ];

            this.model.set('dashboardTitle', constants.USER_GROUPS_SETTINGS_TITLE);
            this.model.set('breadcrumbs', breadcrumbs);
            this.render();
        });
    }

    render() {
        this.onRender();
        var gridData = this.model.get('gridData');

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var self = this;
        let gridObject=util.getGridObject(self,{autowidth:true,scrollOffset:0});
        $(self.gridEl).jqGrid(gridObject);

        if(gridData) {
            gridData.forEach(function (value, index) {
                var newRow = {
                    'GroupId': value['id'] || value['GroupId'],
                    'GroupGUID': value['guid'] || value['GroupGUID'],
                    'Name': value['label'] || value['Name']
                };
                $(self.gridEl).addRowData(index, newRow);
            });
        }

        $('#detailHeading').html('Settings - Dashboard');
        $(`option[value="${this.model.get('search-role')}"]`).prop('selected', true);

        this.resizeGrid();
        this.delegateEvents();

        this.afterRender();
        this.$el.css('cursor', 'default');
        return this;
    }

    remove(){
        $(window).unbind('resize');
        super.remove();
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
}

export default UserGroupSearchDetailView;

